import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { StrategyListComponent } from "@m19-board/strategies/strategy-list/strategy-list.component";

@UntilDestroy()
@Component({
  selector: "app-tacos-manager",
  templateUrl: "./tacos-manager.component.html",
  imports: [StrategyListComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TacosManagerComponent {}
